var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AI-attendance"},[_vm._v("\n    AI-attendance\n        ")])
}
var staticRenderFns = []

export { render, staticRenderFns }